var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado"}},[(!_vm.$vuetify.breakpoint.mobile)?[_c('desktop',{attrs:{"desktop":"","reportesFisicos":_vm.getReportesFisicos}})]:[_c('mobile',{attrs:{"reportesFisicos":_vm.getReportesFisicos}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }